import {Injectable, signal} from '@angular/core';
import {NonNullableFormBuilder} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import moment from 'moment';
import {TmtErpOutboundPanelFilterForm, TmtErpOutboundPanelFilterModel} from '../models/tmt-erp-outbound-panel-filter-model';

@Injectable({
  providedIn: 'root'
})
export class TmtErpOutboundPanelFilterService {
  public readonly toggleModal = signal(false);

  public readonly filtersValue = signal<TmtErpOutboundPanelFilterModel>(this.buildDefaultFilters());

  private readonly filters$ = new BehaviorSubject<TmtErpOutboundPanelFilterModel>(this.filtersValue());

  public get form(): TmtErpOutboundPanelFilterForm {
    return this.formBuilder.group({
      InvoiceNumber: [null as string | null],
      PNR: [null as string | null],
      ErpMessageId: [null as string | null],
      ErpOrderNumber: [null as string | null],
      LegalEntityId: [null as number | null],
      QueueName: [null as string | null],
      ResponseType: [null as string | null],
      Result: [null as string | null],
      CreatedDateFrom: [null as Date | null],
      CreatedDateTo: [null as Date | null],
      SalesOrderSyncQueueId: [null as number | null],
      HasSalesOrderNumber: [null as boolean | null],
      HasSalesOrderSyncQueueId: [null as boolean | null]
    });
  }

  constructor(private readonly formBuilder: NonNullableFormBuilder) {}

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: TmtErpOutboundPanelFilterModel) {
    this.filters$.next(value);
    this.filtersValue.set(value);
  }

  public buildDefaultFilters(): TmtErpOutboundPanelFilterModel {
    return {
      InvoiceNumber: null,
      PNR: null,
      ErpMessageId: null,
      ErpOrderNumber: null,
      LegalEntityId: null,
      QueueName: null,
      ResponseType: null,
      Result: null,
      CreatedDateFrom: moment().subtract(7, 'days').startOf('day').toDate(),
      CreatedDateTo: moment().endOf('day').toDate(),
      SalesOrderSyncQueueId: null,
      ReloadGrid: false,
      HasSalesOrderNumber: true,
      HasSalesOrderSyncQueueId: null
    };
  }
}
